import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    rtl: false,
    showDrawer: false,
    isAuthenticated: false,
    supportedCurrencies: [],
    currencyTable: null,
    authenticatedUser: null,
    authenticatedUserRole: null,
    authenticatedUserPermissions: [],
    subscriptionInfo: null,
    subscriberInfo: null,
  },
  getters: {
    rtl: state => state.rtl,
    showDrawer: state => state.showDrawer,
    currency: state => state.subscriberInfo?.basicInfo?.currency ?? "",
    isLocaleEnabled: _ => process.env.VUE_APP_LOCALE !== "false",
  },
  mutations: {
    UPDATE_RTL: (state, value) => {
      if (value != null) state.rtl = value;
    },
    TOGGLE_APP_DRAWER: state => {
      state.showDrawer = !state.showDrawer;
    },
    CLOSE_APP_DRAWER: state => {
      if (state.showDrawer) state.showDrawer = false;
    },
    SET_AUTHENTICATED: (state, value) => {
      if (value != null) state.isAuthenticated = value;
    },
    SET_SUPPORTED_CURRENCIES: (state, value) => {
      if (value != null) state.supportedCurrencies = value;
    },
    SET_CURRENCY_TABLE: (state, value) => {
      if (value != null) state.currencyTable = value;
    },
    SET_AUTHENTICATED_USER: (state, value) => {
      if (value != null) {
        state.authenticatedUser = value === "REMOVE" ? null : value;
      }
    },
    SET_AUTHENTICATED_USER_ROLE: (state, value) => {
      if (value != null) {
        state.authenticatedUserRole = value === "REMOVE" ? null : value;
      }
    },
    SET_AUTHENTICATED_USER_PERMISSIONS: (state, value) => {
      if (value != null) {
        state.authenticatedUserPermissions = value === "REMOVE" ? [] : value;
      }
    },
    SET_SUBSCRIPTION_INFO: (state, value) => {
      if (value != null) {
        state.subscriptionInfo = value === "REMOVE" ? null : value;
      }
    },
    SET_SUBSCRIBER_INFO: (state, value) => {
      if (value != null) {
        state.subscriberInfo = value === "REMOVE" ? null : value;
      }
    },
  },
  actions: {
    toggleAppDrawer({ commit }) {
      commit("TOGGLE_APP_DRAWER");
    },
    closeAppDrawer({ commit }) {
      commit("CLOSE_APP_DRAWER");
    },
  },
});
